/**
 * SECTION - EDUCATION
 */

import RouteSelector from "../containers/RouteSelector";
import LocalSelector from "../containers/LocalSelector";
import { views } from "./../services/constants";

const { education, internal } = views;

const EducationRoutes = {
  routes: [
    /*{
      path: ["/study", "/estudar"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "education"
      }
    },
    {
      path: ["/academic-support", "/apoio-academico"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "academicSupport"
      }
    },
    {
      path: ["/libraries", "/bibliotecas"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "libraries"
      }
    },
    {
      path: ["/teaching-support", "/apoio-ensino"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "teachingSupport"
      }
    },

    {
      path: ["/teaching-support-faq", "/apoio-ensino-faq"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "teachingFaq"
      }
    },
    {
      path: ["/study-support", "/apoio-estudo"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "studySupport"
      }
    },*/
    {
      path: ["/course-types", "/tipo-curso"],
      component: LocalSelector,
      props: {
        activeView: education,
        document: "degrees"
      }
    },
    /*{
      path: ["/other-post-grad", "/outras-pos-grad"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "otherPostGrad"
      }
    },
    {
      path: ["/more-learning", "/estudar-mais"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "moreLearning"
      }
    },
    {
      path: ["/applications", "/candidaturas"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "aplications"
      }
    },
    {
      path: ["/cna", "/cna"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "cna"
      }
    },
    {
      path: ["/local-application", "/concurso-local"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "localApplication"
      }
    },
    {
      path: ["/post-grad-applications", "/candidaturas-pos-grad"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "postGradApplications"
      }
    },
    {
      path: ["/special-admissions", "/concursos-especiais"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "specialAdmissions"
      }
    },
    {
      path: ["/international-students", "/estudantes-internacionais"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "internationalStudents"
      }
    },
    {
      path: ["/m23", "/m23"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "MTwentyThree"
      }
    },
    {
      path: ["/professional-integration", "/estagios-emprego"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "professionalIntegration"
      }
    },
    {
      path: ["/tesp-info", "/tesp-info"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "tespInfo"
      }
    },*/
    {
      path: ["/edicts/:degree?", "/editais/:degree?"],
      component: LocalSelector,
      props: {
        activeView: education,
        document: "edicts"
      }
    } /*,
    {
      path: ["/study-info", "/estudar-info"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "studyInfo"
      }
    },
    {
      path: ["/scholarships-awards", "/bolsas-premios"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "scholarshipsAwards"
      }
    },
    {
      path: ["/start-programme", "/programa-start"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "startProgramme"
      }
    },
    {
      path: ["/start-exams-programme", "/programa-start-exames"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "startExams"
      }
    },
    {
      path: ["/preparation-courses", "/cursos-nivelamento"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "preparationCourses"
      }
    },
    {
      path: ["/exams", "/exames"],
      component: RouteSelector,
      props: {
        activeView: "education",
        document: "examsInterviews"
      }
    },
    {
      path: ["/isolated-subjects", "/uc-isoladas"],
      component: RouteSelector,
      props: {
        activeView: education,
        document: "isolatedSubjects"
      }
    }*/
  ]
};

export default EducationRoutes;
